<template>
  <div class="flex justify-center mt-2 mb-10 flex-col items-center">
    <Loading
      class="border w-1/2 py-4"
      :isLoading="isLoadingTours"
      :hasError="errorLoadingTours"
      message="Loading..."
    >
      <div
        class="flex flex-grow flex-col justify-center items-center"
        slot="success"
      >
        <BaseButton
          class="border border-black rounded-sm py-2 px-4"
          @click="showTour"
        >
          Show Tour
        </BaseButton>
        <BaseButton
          class="border border-black rounded-sm py-2 px-4 mt-2"
          @click="clearCookie('playground-tour')"
        >
          Clear Cookie
        </BaseButton>
        <TheTour
          :showing="showing"
          @finish="showing = false"
          @close="showing = false"
          :steps="steps"
          id="playground-tour"
        />

        <BaseButton
          class="border border-black rounded-sm py-2 px-4 mt-2"
          @click="showingSecondTour = true"
        >
          Show Second Tour
        </BaseButton>
        <BaseButton
          class="border border-black rounded-sm py-2 px-4 mt-2"
          @click="clearCookie('second-playground-tour')"
        >
          Clear Second Cookie
        </BaseButton>
        <TheTour
          :showing="showingSecondTour"
          @finish="showingSecondTour = false"
          @close="showingSecondTour = false"
          :steps="secondTourSteps"
          id="second-playground-tour"
        />
      </div>
      <div class="flex flex-grow" slot="error">
        <LoadingError
          icon="user-error"
          iconHeight="30"
          iconWidth="30"
          :withRetry="true"
          message="We're having trouble loading your tours."
          subMessage="Please try again."
          @retry="loadTours"
        />
      </div>
    </Loading>

    <h1 class="mt-8 mb-0">
      Adds notification to notification system
    </h1>
    <BaseButton
      class="border border-black rounded-sm py-2 px-4 mt-2"
      @click="onClickAddNotification"
    >
      Add Notification
    </BaseButton>

    <h1 class="mt-8 mb-0">
      Throws error (which will be caught by the error boundary on the app)
    </h1>
    <BaseButton
      class="text-white border border-red-600 bg-red-600 rounded-sm py-2 px-4 mt-2"
      @click="throwError"
    >
      Throw Error
    </BaseButton>

    <h1 class="mt-8 mb-0">
      Throws error (which will be caught by the error boundary on this button)
    </h1>
    <ErrorBoundary name="PlaygroundButtonErrorBoundary">
      <BaseButton
        class="text-white border border-red-600 bg-red-600 rounded-sm py-2 px-4 mt-2"
        @click="throwError"
      >
        Throw Contained Error
      </BaseButton>
    </ErrorBoundary>

    <h1 class="mt-8 mb-0">
      Starts request that alternates between success and failure and responds by
      putting appropriate message on notification system
    </h1>
    <BaseButton
      class="border border-black rounded-sm py-2 px-4 mt-2"
      @click="handleAlternatingRequest"
    >
      Start Alternating Request
    </BaseButton>
  </div>
</template>

<script>
import {
  ErrorBoundary,
  Loading,
  LoadingError,
  TheTour
} from '@listen360/alexandria'
import { createNamespacedHelpers } from 'vuex'
import cookie from 'js-cookie'

import { getRequestSuccessOrFail } from '../utils/api_mock'

const { mapActions } = createNamespacedHelpers('notifications')
const alertTypes = ['error', 'info', 'success', 'warning']
let count = 0

export default {
  name: 'Playground',
  components: {
    ErrorBoundary,
    Loading,
    LoadingError,
    TheTour
  },
  data() {
    return {
      errorLoadingTours: false,
      isLoadingTours: false,
      showing: false,
      showingSecondTour: false,
      secondTourSteps: [
        {
          imageSrc: '/images/menu-zoom.png',
          heading: 'This is a second tour on same page.',
          description:
            'You might have noticed your dashboard looks a little different! Simply click the dropdown in the top left to start navigating your organization.'
        },
        {
          imageSrc: '/images/menu-zoom.png',
          heading: 'This is the second step.',
          description: 'This is the second step description.'
        }
      ],
      steps: [
        {
          imageSrc: '/images/menu-zoom.png',
          heading: 'Navigating your organization is easier than ever.',
          description:
            'You might have noticed your dashboard looks a little different! Simply click the dropdown in the top left to start navigating your organization.'
        },
        {
          imageSrc: '/images/menu-zoom.png',
          heading: 'This is the second step.',
          description: 'This is the second step description.'
        }
      ]
    }
  },
  mounted() {
    this.loadTours(true)
  },
  methods: {
    ...mapActions(['addNotification']),
    onClickAddNotification() {
      count++

      this.addNotification({
        id: `message-${count}`,
        alertType: alertTypes[count % alertTypes.length],
        message: 'Your message would go here'
      })
    },
    handleAlternatingRequest() {
      getRequestSuccessOrFail()
        .then(() => {
          this.addNotification({
            id: `message-${count++}`,
            alertType: 'success',
            message: 'Your SUCCESS message would go here'
          })
        })
        .catch(() => {
          this.addNotification({
            id: `message-${count++}`,
            alertType: 'error',
            message: 'Your ERROR message would go here'
          })
        })
    },
    throwError() {
      throw new Error('something bad happened')
    },
    showTour() {
      this.showing = true
    },
    clearCookie(id) {
      cookie.remove(`has-seen-tour-${id}`)
      window.location.reload()
    },
    loadTours(withError = false) {
      this.isLoadingTours = true

      setTimeout(() => {
        this.isLoadingTours = false
        this.errorLoadingTours = withError
      }, 1000)
    }
  }
}
</script>
